import script from "./ProjectsAndStoragePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsAndStoragePage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectsAndStoragePage.vue?vue&type=style&index=0&id=80e538ca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80e538ca"]])

export default __exports__